export const GET_ROLES_REQUEST = 'GET_ROLES_REQUEST';
export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST';
export const GET_ROLE_EXPANDED_PERMISSIONS_REQUEST = 'GET_ROLE_EXPANDED_PERMISSIONS_REQUEST';
export const GET_ROLE_USERS_REQUEST = 'GET_ROLE_USERS_REQUEST';
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';

export const getRoles = (callback) => ({
    type: GET_ROLES_REQUEST,
    payload: { callback },
});

export const getRole = (roleId, callback) => ({
    type: GET_ROLE_REQUEST,
    payload: { roleId, callback },
});

export const getRoleExpandedPermissions = (roleId, callback) => ({
    type: GET_ROLE_EXPANDED_PERMISSIONS_REQUEST,
    payload: { roleId, callback },
});

export const getRoleUsers = (roleId, params, callback) => ({
    type: GET_ROLE_USERS_REQUEST,
    payload: { roleId, params, callback },
});

export const createRole = (roleData, callback) => ({
    type: CREATE_ROLE_REQUEST,
    payload: { roleData, callback },
});

export const updateRole = (roleId, roleData, callback) => ({
    type: UPDATE_ROLE_REQUEST,
    payload: { roleId, roleData, callback },
});

export const deleteRole = (roleId, migrateTo, callback) => ({
    type: DELETE_ROLE_REQUEST,
    payload: { roleId, migrateTo, callback },
});
